import React from 'react';
import PropTypes from 'prop-types';

import { ChirpButton } from 'javascripts/components/chirp_button';
import { Modal } from 'javascripts/components/modal';

import styles from 'stylesheets/components/person_follow_education_modal';

export function PersonFollowEducationModal({ isOpen, onRequestClose, personName }) {
  function renderHeader() {
    return (
      <div className={styles.header}>
        <p className={styles.following}>{`Now following ${personName}`}</p>
        <p className={styles.heading}>Author Follows</p>
      </div>
    );
  }
  function renderModalContent() {
    return (
      <div className={styles.modalContent}>
        <div className={styles.text}>
          When you follow an author on Chirp we will automatically notify you about any new deals or new releases by
          that author.
        </div>
        <ChirpButton label='Okay' displayStyle='yellow' onClick={onRequestClose} fullWidth />
      </div>
    );
  }

  return (
    <Modal isOpen={isOpen} onRequestClose={onRequestClose} header={renderHeader()} darkHeader>
      {renderModalContent()}
    </Modal>
  );
}

PersonFollowEducationModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onRequestClose: PropTypes.func.isRequired,
  personName: PropTypes.string.isRequired,
};

PersonFollowEducationModal.defaultProps = {
  isOpen: false,
};
